module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_ro_romanian-6d757067ccc276327b1b444f1f3789cc.svg";